define((require) => {
    "use strict";

    const $ = require("jquery");

    return class {
        static fetchIcon(model) {
            return $.ajax({
                url: model.getIconUrl(),
                crossDomain: true
            })
                .then((result) => result.documentElement);
        }
    };
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/button/ButtonWidgetHelper.js